/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Payneteasy
 */
export class Payneteasy {
    /**
     *
     * @type {string}
     * @memberof Payneteasy
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Payneteasy
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Payneteasy
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Payneteasy
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Payneteasy
     */
    groupId: string;
    /**
     *
     * @type {boolean}
     * @memberof Payneteasy
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Payneteasy
     */
    autoApprove: boolean;
}
